<div class="error" *ngIf="errcode && !errorHeader">
    <app-error [errcode]="errcode"></app-error>
</div>
<div class="link-error-container" *ngIf="errorHeader">
    <img src="assets/icons/Protected.svg">
    <div class="info">
        <div class="h5">{{errorHeader}}</div>
        <div class="body-1">Error #{{errcode.code}}</div>
    </div>
    <div class="body-1"> Please contact the owner of this link. </div>
    <sync-button 
        type="outlined"
        label="Sign into Sync"
        size="large"
        [onClick]="redirectToLogin"
    ></sync-button>
</div>